import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/calendar.svg';

export const IconCalendar = createIconComponent(Icon);
